export const setJwt = token => (localStorage.jwt = token);

export const getJwt = () => localStorage.jwt;

export const setMyInfo = info => (localStorage.myInfo = JSON.stringify(info));

export const getMyInfo = () => (localStorage.myInfo ? JSON.parse(localStorage.myInfo) : {});

export const setPermission = permission => (localStorage.permission = JSON.stringify(permission));

export const getPermission = () => (localStorage.permission ? JSON.parse(localStorage.permission) : []);
